import { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  name: string;
  width?: string;
  background?: string
}

export const Button = ({ name, width, background, ...rest }: ButtonProps) => {
  return (
    <button
      {...rest}
      className={`${width ? width : "w-full"
        } h-8 rounded-md ${background ? background : "bg-primary"
        }  text-center text-white`}
    >
      {name}
    </button>
  );
};
